import { Injectable } from '@angular/core';
import { CustomerStoreService } from '@app/ngrx-customer/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ORDER_ACTIONS } from '@order/actions/order-actions';
import { OrderDownloadService } from '@shared/services/file-download/order-download.service';
import { OrderInsightsDownloadService } from '@shared/services/file-download/order-insights-download.service';
import { Order } from '@usf/ngrx-order';
import { combineLatest, mergeMap, of, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderInsightsEffects {
  downloadOrderInsights$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ORDER_ACTIONS.downloadOrderInsights),
        tap(downloadInsightsEvent => {
          this.orderInsightsDownloadService.downloadOrderInsightsFile(
            downloadInsightsEvent,
          );
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private orderInsightsDownloadService: OrderInsightsDownloadService,
  ) {}
}
